import { socketNotification } from '@nxsys/services/sockets';
import { useCallback, useEffect } from 'react';

export type SocketEvent = {
  type: string;
  success?: boolean;
  message?: string;
  data?: any;
  progress?: number;
  error?: {
    message: string;
  };
};

export type UseSocketOptions = {
  eventName: string;
  onSuccess?: (data: any) => void;
  onError?: (error: string) => void;
};

export const useNotificationSocket = (options: UseSocketOptions): void => {
  const { eventName, onSuccess, onError } = options;

  const handleSocketEvent = useCallback(
    (eventData: SocketEvent) => {
      if (eventData?.success) {
        onSuccess?.(eventData);
      } else {
        onError?.(eventData?.error?.message || '');
      }
    },
    [onSuccess, onError],
  );

  useEffect(() => {
    // Set up socket event listeners
    socketNotification.on(eventName, handleSocketEvent);

    // Cleanup function
    return () => {
      socketNotification.off(eventName, handleSocketEvent);
    };
  }, [handleSocketEvent]);
};

export default useNotificationSocket;
